export default __webpack_public_path__ + "static/media/folder-back-icon.8859bd8f.jpg";